<template>
    <section :class="css.container" ref="container">
        <div :class="css.header">
            <div class="container" :class="css.header_body">
                <h2 :class="css.title" class="font-variable color-1 font-bold">{{ $t("ProteinInteraction") }}</h2>
                <UiTooltip :zIndex="68" :width="600" direction="bottom" align="start" :classExtraName="css_normalize.tip">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/2ab0cd5c-44fb-4516-a336-122259998a12.webp" alt="" />
                    <template #content>
                        <div :class="css_normalize.context">{{ $t("ProteinInteractionDesc1") }}</div>
                        <div :class="css_normalize.indexs">
                            <div :class="css_normalize.index">{{ $t("ProteinInteractionDesc2") }}</div>
                            <div :class="css_normalize.index">
                                <i18n-t :class="css.imgs" tag="span" keypath="ProteinInteractionDesc3">
                                    <template #icon>
                                        <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/9e145d68-7e36-4d0d-8c3b-05feab79df66.webp" alt="" />
                                    </template>
                                    <template #icon2>
                                        <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/99a218ca-190b-417f-9afe-f74d68cdebda.webp" alt="" />
                                    </template>
                                    <template #icon3>
                                        <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/5173dea6-25a2-4f5a-91ee-6145bb083ac1.webp" alt="" />
                                    </template>
                                    <template #icon4>
                                        <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/3f99e224-8e88-4934-8d85-e24e6126fe8e.webp" alt="" />
                                    </template>
                                </i18n-t>
                            </div>
                            <div :class="css_normalize.index">{{ $t("ProteinInteractionDesc4") }}</div>
                            <div :class="css_normalize.index">{{ $t("ProteinInteractionDesc5") }}</div>
                            <div :class="css_normalize.index">{{ $t("ProteinInteractionDesc6") }}</div>
                            <div :class="css_normalize.index">{{ $t("ProteinInteractionDesc7") }}</div>
                            <div :class="css_normalize.index">{{ $t("ProteinInteractionDesc8") }}</div>
                        </div>
                        <div :class="css_normalize.context">{{ $t("ProteinInteractionDesc9") }}</div>
                    </template>
                </UiTooltip>
            </div>
        </div>

        <div :class="css.error" class="container text-hint" v-if="!exist">{{ $t("TranscriptsProteinsDescript2") }}</div>
        <div :class="css.body" class="container" v-loading="loading" v-else>
            <div :class="css.controls">
                <!-- * 选择器列表 -->
                <div :class="css.selectors">
                    <div v-if="filters.modes?.options?.length" :class="css.module">
                        <div :class="css.name">{{ filters.modes.name }}</div>
                        <ui-select v-model="mode" :class="css.selector" :candidates="filters.modes.options" @change="methods.acquire(1)">
                            <template #candidate="{ data }">
                                <span :title="data.label" v-html="data.label"></span>
                            </template>
                        </ui-select>
                    </div>

                    <div v-if="filters.updowns?.options?.length" :class="css.module">
                        <div :class="css.name">{{ filters.updowns.name }}</div>
                        <ui-select v-model="updown" :class="css.selector" :candidates="filters.updowns.options" @change="methods.acquire(1)">
                            <template #candidate="{ data }">
                                <span :title="data.label" v-html="data.label"></span>
                            </template>
                        </ui-select>
                    </div>

                    <div v-if="filters.mechanisms?.options?.length" :class="css.module">
                        <div :class="css.name">{{ filters.mechanisms.name }}</div>
                        <ui-select
                            v-model="mechanism"
                            :class="css.selector"
                            :class-extra-name="css.candidates"
                            :candidates="filters.mechanisms.options"
                            @change="methods.acquire(1)">
                            <template #candidate="{ data }">
                                <span :title="data.label" v-html="data.label"></span>
                            </template>
                        </ui-select>
                    </div>

                    <div v-if="filters.speciess?.options?.length" :class="css.module">
                        <div :class="css.name">{{ filters.speciess.name }}</div>
                        <ui-select
                            v-model="species"
                            :class="css.selector"
                            :class-extra-name="css.candidates"
                            :candidates="filters.speciess.options"
                            @change="methods.acquire(1)">
                            <template #candidate="{ data }">
                                <span :title="data.label" v-html="data.label"></span>
                            </template>
                        </ui-select>
                    </div>

                    <div v-if="filters.tissues?.options?.length" :class="css.module">
                        <div :class="css.name">{{ filters.tissues.name }}</div>
                        <ui-select
                            v-model="tissue"
                            :class="css.selector"
                            :class-extra-name="css.candidates"
                            :candidates="filters.tissues.options"
                            @change="methods.acquire(1)">
                            <template #candidate="{ data }">
                                <span :title="data.label" v-html="data.label"></span>
                            </template>
                        </ui-select>
                    </div>

                    <div v-if="filters.cells?.options?.length" :class="css.module">
                        <div :class="css.name">{{ filters.cells.name }}</div>
                        <ui-select
                            v-model="cell"
                            :class="css.selector"
                            :class-extra-name="css.candidates"
                            :candidates="filters.cells.options"
                            @change="methods.acquire(1)">
                            <template #candidate="{ data }">
                                <span :title="data.label" v-html="data.label"></span>
                            </template>
                        </ui-select>
                    </div>
                </div>

                <ui-button :class="css.reset" :width="112" @click="methods.reset">{{ $t("Reset") }}</ui-button>
            </div>
            <ui-table2 :class="css.table" :option="options.view" :data="data" ref="table" @sort="methods.sort" :error="$t('NoDataAvailable')">
                <template #effect_name="{ data }">
                    <template v-if="data.effect_name != origin.symbol">
                        <project-route :class="css_normalize.assets" :to="{ name: 'Gene', params: { id: data.effect_id } }">
                            {{ data.effect_name }}
                        </project-route>
                    </template>
                    <template v-else>{{ data.effect_name }}</template>
                </template>
                <template #aminos="{ data }">
                    <template v-if="!data?.aminos?.length">0</template>
                    <template v-else>
                        <div :class="css_normalize.assets" @click="methods.children('aminos', data)">{{ data?.aminos?.length }}</div>
                    </template>
                </template>
                <template #target_name="{ data }">
                    <template v-if="data.target_name != origin.symbol">
                        <project-route :class="css_normalize.assets" :to="{ name: 'Gene', params: { id: data.target_id } }">
                            {{ data.target_name }}
                        </project-route>
                    </template>
                    <template v-else>{{ data.target_name }}</template>
                </template>

                <template #references="{ data }">
                    <template v-if="!data?.references?.length">0</template>
                    <template v-else>
                        <div :class="css_normalize.assets" @click="methods.children('references', data)">{{ data?.references?.length }}</div>
                    </template>
                </template>

                <template #regulation_mode="{ data }">
                    <img :class="css.image" :src="data.regulation_mode" alt="图标" title="图标" />
                </template>

                <template #regulation_mode_extra>
                    <!-- * 全选按钮 -->
                    <ui-checkbox v-model="regulation_mode" :class="css_normalize.checkbox" value="all" @change="methods.regulation_mode">{{
                        $t("SelectAll")
                    }}</ui-checkbox>
                    <!-- * 多选列表 -->
                    <ui-checkbox-group v-model="regulation_modes" @change="methods.regulation_modes" :class="css.checkbox_group">
                        <template v-for="value in filters.regulation_modes?.options">
                            <ui-checkbox :class="css_normalize.checkbox" :value="value.value">
                                <img v-if="value.icon" :src="value.icon" alt="图标" />
                                <span>{{ value.label }}</span>
                            </ui-checkbox>
                        </template>
                    </ui-checkbox-group>
                </template>

                <template #regulatory_detail_extra>
                    <!-- * 全选按钮 -->
                    <ui-checkbox v-model="regulatory_detail" :class="css_normalize.checkbox" value="all" @change="methods.regulatory_detail">{{
                        $t("SelectAll")
                    }}</ui-checkbox>
                    <!-- * 多选列表 -->
                    <ui-checkbox-group v-model="regulatory_details" @change="methods.regulatory_details" :class="css.checkbox_group">
                        <template v-for="value in filters.regulatory_details?.options">
                            <ui-checkbox :class="css_normalize.checkbox" :value="value.value">{{ value.label }}</ui-checkbox>
                        </template>
                    </ui-checkbox-group>
                </template>

                <template #children="{ data }">
                    <module-data :mode="data.mode" :data="data" :origin="origin" />
                </template>
            </ui-table2>

            <ui-pagination v-model="page" :class="css.pagination" :count="count" @change="methods.acquire()">
                <template #items>{{ $t("Layout.PaginationDetails", { count: count, limit: 10 }) }}</template>
            </ui-pagination>
        </div>
    </section>
</template>

<script lang="ts" setup>
//* 组件库
import { UiCheckboxGroup, UiPagination, UiCheckbox, UiTable2, UiButton, UiSelect, UiTooltip } from "various-ui";

//* 私有组件
import ModuleData from "./components/module-data/index.vue";
//* 组件属性
import { ModulePropsOption } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";
import css_normalize from "@/assets/style/src/index.module.less";

//* 组件属性注册
defineProps(ModulePropsOption);

//* 组合函数
const { refs, nodes, options, methods } = useComposable();
const { render, hidden } = methods;
const { table, container } = nodes;
const {
    page,
    data,
    cell,
    mode,
    count,
    exist,
    updown,
    tissue,
    loading,
    species,
    mechanism,
    regulation_mode,
    regulation_modes,
    regulatory_detail,
    regulatory_details,
    filters,
} = refs;

//* 组件属性导出
defineExpose({ render, hidden });
</script>
